import type { ApolloClient } from "@apollo/client";
import { GET_USER } from "api/query";
import { mergeUiState, readUiState } from "api/uiState";
import type { GetProjectQuery, GetUserQuery } from "graphql/generated";
import { statsig, updateStatsigUser } from "utils/statsig";

/**
 * Follows a project switch: sets the Statsig user to the project, and saves it
 * as the user's selection, so that a refresh or the next login opens it. A
 * project that is already set is skipped.
 */
export const syncProject = async (
  client: ApolloClient<object>,
  project: GetProjectQuery["getProject"],
) => {
  const user = client.readQuery<GetUserQuery>({ query: GET_USER })?.getUser;
  await Promise.all([
    statsig.getContext().user?.userID === project.id
      ? undefined
      : updateStatsigUser({
          projectId: project.id,
          email: user?.email,
          userId: user?.id,
          custom: {
            project_created: project.created,
            planType: project.entitlementSpec?.plan_type,
          },
        }),
    readUiState(client).selectedProjectId === project.id
      ? undefined
      : mergeUiState(client, { selectedProjectId: project.id }),
  ]);
};
